<web-design-system-modal
  [headline]="'trade.create.check-experience-and-ftg.showNoWalletWarning.headline' | transloco"
  (dismiss)="modal.close('cancel')"
  data-zid="experience-container"
>
  <div class="row">
    <div class="col-12 mb-4">
      {{ 'trade.create.check-experience-and-ftg.showNoWalletWarning.text' | transloco }}
      <a class="link-secondary" [routerLink]="VERWALTUNG_URL" [queryParams]="{ section: 'krypto-wallet' }" (click)="modal.close()">{{
        'trade.create.check-experience-and-ftg.showNoWalletWarning.link' | transloco
      }}</a>
    </div>
  </div>
</web-design-system-modal>
